
import { reactive, ref, toRefs } from 'vue'
import { random } from 'lodash'
import { useStore } from 'vuex'
import { useAxiosPlaying } from '@/axios/index.ts'
import { useRoute } from 'vue-router'
import { SUCCESS } from '@/constants'

interface axiosFormat {
  data: any
  statusCode: string
}

const roulette = ref()

export default {
  emits: ['finishGame', 'over', 'openPopup', 'setClosePopupCallback'],
  props: {
    playTimes: {
      type: [Number, String],
      default: 0
    },
    imgCircleUrl: {
      type: String,
      default: ''
    },
    imgPointUrl: {
      type: String,
      default: ''
    },
    haveCube: {
      type: Boolean,
      default: true
    }
  },
  setup(props: any, context: any) {
    const store = useStore()
    const route = useRoute()
    const name = ref('')
    const member_card = ref('')
    const { query } = route
    let status = ''

    // settimeout id
    let executeSpin: undefined | number
    // 目前角度
    let targetDegress: null | number
    // 正在移動角度
    let workingDegress: number = 0
    // 獎項格數
    let maxLength: number = 8
    // animation id
    let listenBrowserAnimation: null | number
    // 計算圈數
    let countTurn: number = 0
    // 控制轉盤速度
    let counter: number = 0
    // 結束的圈數
    let targetTurn: null | number
    let winData = {
      play_times: -1,
      prize_name: '',
      prize_point: '',
      prize_type: -1,
      sort: -1,
      statusCodeType: '',
      wording: ''
    }

    function initRoulette() {
      clearInterval(executeSpin)
        if (listenBrowserAnimation) {
          window.cancelAnimationFrame(listenBrowserAnimation)
        }
        executeSpin = undefined
        targetTurn = null
        targetDegress = null
        counter = 0

        if (status === SUCCESS) {
          context.emit('finishGame', winData)
        } else {
          store.state.status.code = status
        }
    }

    function playGame() {
      if (props.playTimes <= 0) {
        context.emit('over')
        return
      }
      if (executeSpin != undefined) return

      targetDegress = null
      workRoulette()
      useAxiosPlaying(name.value, member_card.value, 1)
        .then(jsonData => {
          const { data: result, statusCode } = jsonData.data
          status = statusCode
          winData = result
          finishGame()
        })
        .catch(error => {
          console.warn('useAxiosPlaying', error)
          context.emit('openPopup', 'loudspeaker', 1)
          context.emit('setClosePopupCallback', () => {
            winData = {
              play_times: 1,
              prize_name: '',
              prize_point: '',
              prize_type: -1,
              sort: -1,
              statusCodeType: '',
              wording: ''
            }
            initRoulette()
          })
        })
    }
    function workRoulette() {
      listenBrowserAnimation = window.requestAnimationFrame(spinRoulette)
      workingDegress = workingDegress + 2
      if (workingDegress >= 360) {
        workingDegress = 0
        countTurn++
      }
      // workingDegress equals targetDegress need to stop
      if (typeof targetTurn === 'number' && typeof targetDegress === 'number') {
        if (countTurn === targetTurn && workingDegress >= targetDegress) {
          initRoulette()
          return
        }
      }
      executeSpin = setTimeout(function() {
        workRoulette()
      }, switchSpeedTime())
    }
    function spinRoulette() {
      roulette.value.setAttribute(
        'style',
        `transform:rotate(${workingDegress}deg);`
      )
    }
    function finishGame() {
      getWinNumber()
      getTargetTurn()
    }
    function getWinNumber() {
      // get 0 ~ 7 random number
      // const indexNumber = random(0, maxLength - 1)
      const indexNumber = winData.sort || 0
      const indexDegress = random(
        indexNumber * 45 + 10,
        indexNumber * 44 + 45 - 10
      )
      targetDegress = 360 - indexDegress
    }
    function getTargetTurn() {
      const distance =
        typeof targetDegress === 'number' ? targetDegress - workingDegress : 0
      if (distance < 200) {
        targetTurn = countTurn + 3
      } else {
        targetTurn = countTurn
      }
    }
    function switchSpeedTime() {
      if (typeof targetTurn === 'number') {
        counter++
        return counter / 30
      } else {
        return 1
      }
    }

    // set query value for playing parameter
    function setQueryValue() {
      if (typeof query.name === 'string' && query.name !== '') {
        name.value = query.name
        // name.value = '1213'
      }
      if (typeof query.linkCode === 'string' && query.linkCode !== '') {
        member_card.value = query.linkCode
        // member_card.value = '1232432'
      }
    }

    initRoulette()
    setQueryValue()

    return {
      roulette,
      playGame,
      finishGame,
    }
  }
}
